import { callAPI } from 'Action';
import { appConstantUrl } from 'appConstant';
import { MANUAL_SUBMIT, MANUAL_SUCCESS } from './types';

export const manualSubmit = (value: any) => async (dispatch: any) => {
  let url = appConstantUrl.manualSubmitUrl;
  let reqObj = value;

  const options = {
    url,
    actionType: MANUAL_SUBMIT,
    method: 'POST',
    reqObj,
    dispatch,
  };
  try {
    let data = await callAPI(options);
    if (data) {
      dispatch({
        type: MANUAL_SUBMIT,
        payload: data,
      });
      return data; // Return the response data
    } else {
      dispatch({
        type: 'MANUAL_ERROR',
        payload: null,
      });
      return null;
    }
  } catch (error) {
    dispatch({
      type: 'MANUAL_ERROR',
      payload: null,
    });
    throw error; // Rethrow the error to be caught in the component
  }
};
export const resetManualEntry = () => (dispatch: any) => {
  dispatch({
    type: 'RESET_ERRORS',
  });
  dispatch({ type: MANUAL_SUBMIT, payload: null });
  dispatch({ type: MANUAL_SUCCESS, payload: null });
};
